import { WidgetBootstrapParams, WidgetBootstrapResponse } from 'types/bootstrap'

import { BootstrapApi } from '.'
import { getDefaultAuthParams } from './auth'

export const widgetBootstrap = (orgId: number, params: WidgetBootstrapParams) => {
  const defaultAuthParams = getDefaultAuthParams(orgId)
  return BootstrapApi.post<WidgetBootstrapResponse>('widget_bootstrap', {
    data: { ...defaultAuthParams, ...params }
  })
}
